import { useEffect, useState } from 'react'
import useStepTemplate from 'hooks/useStepTemplate'
import { pidgeyEmailDelivery } from 'services/pidgey'
import { useFirebolt } from '@iq-firebolt/client'
import { useGetApplication } from 'hooks/useGetApplication'

const useFirstStep = ({
  fireboltStep,
  customGoBack,
  customSubmit,
  partnerFormName,
  partnerBrand,
}) => {
  const { application } = useGetApplication()
  const { capturedData } = useFirebolt()
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
    customGoBack,
  })

  const [skipper, setSkipper] = useState({})
  useEffect(() => {
    if (capturedData.cpf) {
      setSkipper(capturedData)
    }
  }, [capturedData, setSkipper])

  function handleSubmit(payload) {
    const formData = {
      ...payload,
      choosen_card: partnerFormName,
    }

    // pidgeyEmailDelivery(formData, application)

    // FIXME: Temp, until the backend stops looking at ab_test_caf field
    fireboltStep?.goNextStep({
      ...payload,
      choosen_card: partnerFormName,
      issuer: partnerBrand,
      ab_test_caf: true,
    })
  }

  return {
    handleGoBackform,
    runBeforeChangeStep,
    handleSubmit,
    skipper,
  }
}

export default useFirstStep
